import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const VALID = ["hni", "professional", "retiree"];

const PERSONA_COPY = {
  hni: "Loading the HNI / business-owner demo…",
  professional: "Loading the working-professional demo…",
  retiree: "Loading the retiree demo…",
};

export default function DemoLauncher() {
  const { persona } = useParams();
  const { startDemo } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    if (!VALID.includes(persona)) {
      setError("That demo doesn't exist.");
      return;
    }

    (async () => {
      try {
        await startDemo(persona);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError("We couldn't start the demo right now. Please try again.");
      }
    })();
  }, [persona, startDemo, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 dark:bg-slate-950 p-6">
      <div className="text-center max-w-md">
        <div className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-emerald-500 to-blue-600 text-white text-2xl font-display font-bold">
          A
        </div>
        {!error ? (
          <>
            <div className="mt-6 flex items-center justify-center gap-2 text-slate-600 dark:text-slate-300">
              <span className="h-4 w-4 rounded-full border-2 border-emerald-500 border-t-transparent animate-spin" />
              <span className="text-sm font-medium">
                {PERSONA_COPY[persona] || "Preparing your demo…"}
              </span>
            </div>
            <p className="mt-3 text-xs text-slate-400">
              Setting up a fully-populated AccessWealth account just for you.
            </p>
          </>
        ) : (
          <>
            <h1 className="mt-6 font-display text-xl font-bold text-slate-900 dark:text-white">
              {error}
            </h1>
            <div className="mt-4 flex items-center justify-center gap-3">
              <button
                onClick={() => window.location.reload()}
                className="btn-primary !text-xs"
              >
                Try again
              </button>
              <Link to="/" className="btn-secondary !text-xs">
                Back to home
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
